import React from "react";
import "./chart.css";

import {
  AreaChart,
  Area,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Jan",
    Total: 1200,
  },
  {
    name: "Feb",
    Total: 1000,
  },
  {
    name: "Mar",
    Total: 1500,
  },
  {
    name: "Apr",
    Total: 800,
  },
  {
    name: "May",
    Total: 2100,
  },
  {
    name: "June",
    Total: 1200,
  },
  {
    name: "Jul",
    Total: 1860,
  },
  {
    name: "Aug",
    Total: 1200,
  },
  {
    name: "Sept",
    Total: 1700,
  },
  {
    name: "Oct",
    Total: 1000,
  },
  {
    name: "Nov",
    Total: 1700,
  },
  {
    name: "Dec",
    Total: 1200,
  },
];

const AreaGraph = (props) => {
  return (
    <div className="chart">
      <div className="title">{props.title}</div>
      <ResponsiveContainer width="100%" height={350}>
        <AreaChart
          width={730}
          height={250}
          data={data}
          margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
        >
          <defs>
            <linearGradient id="total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#9900ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#9900ff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" stroke="gray" fontSize={15} />
          <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="Total"
            stroke="#9900ff"
            fillOpacity={1}
            fill="url(#total)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaGraph;
